// export const API_URL  = 'http://localhost:4000/auth/';
// export const BASE_URL = 'http://localhost:4000/';
export const API_URL  = 'https://iammusicapi.herokuapp.com/auth/';
export const BASE_URL = 'https://iammusicapi.herokuapp.com/';